"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdvancedForm = void 0;
const zod_1 = require("@hookform/resolvers/zod");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const react_intl_1 = require("react-intl");
const utils_1 = require("./utils");
/** @deprecated Use useValueForm */
const useAdvancedForm = (props) => {
    const { defaultValues } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const makeSchema = props.schema;
    const schema = (0, react_1.useMemo)(() => makeSchema(formatMessage), [formatMessage, makeSchema]);
    const checkObject = (x) => ('shape' in x && typeof x.shape === 'object');
    const checkArray = (x) => (x._def.typeName === 'ZodArray');
    const getRequired = (path) => {
        const element = path.split('.').reduce((acc, x) => {
            if (!acc)
                return undefined;
            if (checkObject(acc))
                return acc.shape[x];
            if (checkArray(acc))
                return acc._def.type;
            return undefined;
        }, schema);
        if (!element)
            return false;
        if (element.isOptional())
            return false;
        return true;
    };
    const form = (0, react_hook_form_1.useForm)({
        mode: 'all',
        defaultValues,
        resolver: async (values, context, options) => {
            const validate = (0, zod_1.zodResolver)(schema);
            const result = await validate(values, context, options);
            return result;
        },
        shouldFocusError: false,
    });
    const { register, formState: { errors }, handleSubmit, watch, setValue, } = form;
    const getError = (path) => {
        const element = path.split('.').reduce((acc, x) => acc === null || acc === void 0 ? void 0 : acc[x], errors);
        return element === null || element === void 0 ? void 0 : element.message;
    };
    const field = (path, options) => {
        const { dataType, upperCase } = options;
        return {
            ...register(path, {
                setValueAs: utils_1.toValueMap[dataType],
                onBlur: (event) => {
                    const target = event === null || event === void 0 ? void 0 : event.target;
                    if (upperCase && dataType === 'string' && target instanceof HTMLInputElement) {
                        const value = target.value.toLocaleUpperCase();
                        setValue(path, value, { shouldValidate: true });
                    }
                },
            }),
            required: getRequired(path),
            error: getError(path),
            key: path,
        };
    };
    const fieldControlled = (path) => {
        return {
            value: watch(path),
            setValue: (value) => {
                setValue(path, value, { shouldValidate: true });
            },
            required: getRequired(path),
            error: getError(path),
            key: path,
        };
    };
    return {
        ...form,
        field,
        fieldControlled,
        getError,
        createSubmit: (onSubmit) => handleSubmit(() => {
            const values = watch();
            const filteredValues = (0, utils_1.removeEmptyValues)(values);
            onSubmit(filteredValues);
        }),
    };
};
exports.useAdvancedForm = useAdvancedForm;
//# sourceMappingURL=form.js.map